import { ProcessingResponse } from "../../../models/api/sift/back/api-processing";
import { Awaited } from "../../../utilities/utility.type";
import { ApiBaseBack } from "../../back/api-base-back";

export class ApiGetProcessing extends ApiBaseBack<ProcessingResponse> {
  constructor(param: { serviceId: string }) {
    super(
      'GET',
      '/api/v1/processing',
      'JSON',
      param,
    );
  }
}
